import React from "react";
import { useRouter } from 'next/router';
// nodejs library that concatenates classes
import classNames from "classnames";
import dynamic from 'next/dynamic';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Loading from 'components/Functions/Loading';

// @material-ui/icons
const Timeline = dynamic(() => import('@material-ui/lab/Timeline'), { loading: () => <Loading /> });
const TimelineItem = dynamic(() => import('@material-ui/lab/TimelineItem'));
const TimelineSeparator = dynamic(() => import('@material-ui/lab/TimelineSeparator'));
const TimelineConnector = dynamic(() => import('@material-ui/lab/TimelineConnector'));
const TimelineContent = dynamic(() => import('@material-ui/lab/TimelineContent'));
const TimelineDot = dynamic(() => import('@material-ui/lab/TimelineDot'));
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';

const Typography = dynamic(() => import('@material-ui/core/Typography'));
const Paper = dynamic(() => import('@material-ui/core/Paper'));

import { Business, BusinessCenter, HomeWork, Cloud, 
  Security, Public, MoreVert
} from '@material-ui/icons';

import { green, red, blue } from '@material-ui/core/colors';

const Footer = dynamic(() => import('/components/Footer/Footer.js'), { loading: () => <Loading /> });

import landingPage from "/styles/jss/bbhost/pages/landingPage.js";
import teamStyle from "/styles/jss/bbhost/pages/landingPageSections/teamStyle.js";
const styles = {
  ...landingPage,
  ...teamStyle,
  textTypo: {
    fontSize: "0.875rem",
    "@media (min-width: 1200px)": {
      fontSize: "1rem",
    },
  },
};

// Sections for this page
import HeaderSection from "pages-sections/HeaderSection.js";
const GridContainer = dynamic(() => import('/components/Grid/GridContainer.js'));

const useStyles = makeStyles(styles);

const SEO = {
  title: "BB Host",
  description: "BB Host Sobre Nós",
  url: "https://www.bbhost.com.br/sobrenos",
  type: "website",
  languageAlternates: [
    {
        hrefLang: 'en',
        href: "https://www.bbhost.com.br/en/sobrenos",
    },
    {
        hrefLang: 'es',
        href: "https://www.bbhost.com.br/es/sobrenos",
    }
  ],
};

export default function AboutUS(props) {
  const classes = useStyles();
  const { locale } = useRouter();
  return (
    <div>
      <HeaderSection name="about_us" seo={SEO} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <div className={classes.section}>
            <GridContainer justifyContent="center" alignItems="center">
                <Timeline align="alternate">
                  <TimelineItem>
                    <TimelineOppositeContent>
                      <Typography variant="body2" color="textSecondary">
                        2013
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot color="primary">
                        <Business/>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Paper elevation={8} className={classes.paper} style={{padding: "4%"}}>
                        <Typography align="center" className={classes.textTypo}>
                          Fundada em 28 de setembro de 2013, a BB Host surgiu como uma opção de bom custo e ótimo atendimento no fornecimento do serviço de TeamSpeak, tendo como serviço secundário servidores VPS.
                        </Typography>
                      </Paper>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent>
                      <Typography variant="body2" color="textSecondary">
                        2015
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot>
                        <BusinessCenter/>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Paper elevation={8} className={classes.paper} style={{padding: "2%"}} >
                        <Typography align="center" className={classes.textTypo}>
                          À medida que fomos ganhando espaço no mercado de TeamSpeak e chegando a ser uma das principais empresas no mercado do ramo, começamos a enfrentar problemas onde nenhuma solução disponível no momento em nosso país nos atendia, devido ao grande fluxo de DDoS e problemas que ocorriam.
                        </Typography>
                      </Paper>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent>
                      <Typography variant="body2" color="textSecondary">
                        2017
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot>
                        <HomeWork/>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Paper elevation={8} className={classes.paper} style={{padding: "4%"}} >
                        <Typography align="center" className={classes.textTypo}>
                          Tentamos utilizar todas as empresas no ramo de datacenter do Brasil, identificando como era o meio de atendimento e qualidade de todas, mas nenhuma supria a nossa necessidade ou agradava no modo de trabalhar.<br/><br/>
                          Buscando sempre um serviço de qualidade e atendimento excepcional, acabamos por não encontrar opções.<br/><br/>
                          Ao ver a empresa sofrendo pela falta de empresas oferecendo serviço na qualidade que desejávamos, começamos a montar nosso próprio datacenter, procurando o que havia de melhor em termos de estrutura e rede.
                        </Typography>
                      </Paper>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent>
                      <Typography variant="body2" color="textSecondary">
                        2018
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot variant="outlined">
                        <Cloud style={{ color: blue[300] }}/>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Paper elevation={8} className={classes.paper} style={{padding: "4%"}} >
                        <Typography align="center" className={classes.textTypo}>
                          Iniciamos então nossa estrutura com mitigação própria, tendo um resultado promissor inicialmente, mas encontradas dificuldades que diversas empresas do ramo sofrem.<br/><br/>
                          Sempre buscando melhorias e otimizações nas nossas soluções, este era o início de uma longa caminhada, a fim de uma solução DDoS completa.<br/><br/>
                        </Typography>
                      </Paper>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent>
                      <Typography variant="body2" color="textSecondary">
                        2020
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot variant="outlined">
                        <Public style={{ color: green[500] }}/>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Paper elevation={8} className={classes.paper} style={{padding: "4%"}} >
                        <Typography align="center" className={classes.textTypo}>
                          Com uma conectividade exemplar, com os principais pops brasileiros, mitigação incomparável, utilizando diversos níveis de mitigações, conseguimos oferecer a qualidade de serviço que sempre estivemos buscando e temos orgulho de fornecer.<br/><br/>
                          Vamos sempre evoluir e melhorar onde for possível e agradecemos todos os clientes que confiaram em nós durante esta jornada, agradecemos também, a todos os futuros clientes que nos dão um voto de confiança para fornecer o que há de melhor no mercado brasileiro!
                        </Typography>
                      </Paper>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent>
                      <Typography variant="body2" color="textSecondary">
                        2021
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot variant="outlined">
                        <Security style={{ color: red[500] }}/>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Paper elevation={8} className={classes.paper} style={{padding: "4%"}} >
                        <Typography align="center" className={classes.textTypo}>
                          Expandimos ainda mais nossa solução Anti-DDoS, com o DDoS Pro.<br/><br/>
                        </Typography>
                      </Paper>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent>
                      <Typography variant="body2" color="textSecondary">
                        2022
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot variant="outlined">
                        <MoreVert style={{ color: blue[500] }}/>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Paper elevation={8} className={classes.paper} style={{padding: "4%"}} >
                        <Typography align="center" className={classes.textTypo}>
                          Buscando sempre reduzir a latência e melhor a expericia dos usuarios, aumentamos nossa capilaridade e segurança.<br/><br/>
                        </Typography>
                      </Paper>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent>
                      <Typography variant="body2" color="textSecondary">
                        2023
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot variant="outlined">
                        <MoreVert style={{ color: blue[500] }}/>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      
                    </TimelineContent>
                  </TimelineItem>
                </Timeline>
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export async function getStaticProps({ req, res }) {
  return {
    props: {}
  }
}